import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiConfig } from '../models/api-config';
import { CriminalRecord,AliasName,ApplicantTaxLien,EvictionRecord,PreviousAddress, SSNTrace, ReferenceVerification, EmploymentVerification } from '../models/ApplicantDataResponses/ApplicantDataResponses';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ScreeningInvite, ScreeningAdditionalData } from '../models/screeningInvite';
import { SearchPackage, SearchRecord, VendorResponseTypes, CustomResponseData, SearchVendors } from '../models/searchPackage';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PackagesLog, LogParserType, ScreeningLog } from '../models/LogEntry';
import { CustomAlias } from '../models/ApplicantDataModels/CustomAlias';
import { CustomAddress } from '../models/ApplicantDataModels/CustomAddress';
import { CreditScoreFactors, CreditReportApplicantInfo, CreditReportAddress, CreditReportEmployer, CreditReportTradeLine, CreditReportInquiry, CreditPublicRecordBag, CreditResponseComment, CreditRepositories, CreditBereau, CreditFinancialSummaryItem } from '../models/ApplicantDataResponses/credit';
import { TLSSocket } from 'tls';
import { AuthService } from './auth.service';
import { GroupedApplicantData, GroupPMScorePointLossReason } from '../models/ApplicantDataModels/GroupedApplicantData';
import { HardDeclineReason, ReviewRequiredReason } from '../models/hardDeclineReason';
import { ReportSummaryItem } from '../models/ApplicantDataModels/ReportSummaryItem';
import * as _ from 'lodash';
import { IdentityResponseData } from '../models/IdentityResponseData';
import { ArgyleViewBag, ArgyleIncomeFetchResponse, AdditionalIncomeSource, ScreeningIncomeOverview, DraftIncomeSource } from '../models/argyle';
import { normalizeArgyleIncomeStream } from '../income-stream-display';
// import { ArgyleViewBag, AdditionalIncomeSource, ScreeningIncomeOverview } from '../models/argyle';
import { ComplianceMarker } from '../models/ComplianceMarker';

@Injectable({
  providedIn: 'root'
})
export class ApplicantDataService {
  applicantId : number;
  aseData : ScreeningAdditionalData[];
  _criminalRecords : Array<CriminalRecord> = new Array<CriminalRecord>();
  _evictionRecords : Array<EvictionRecord> = new Array<EvictionRecord>();
  _rrreasons : Array<ReviewRequiredReason> = new Array<ReviewRequiredReason>();
  groupIncome: any;

  public get criminalRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "multistate";})
    else return []; 
  }

  _countyCriminalRecords : Array<CriminalRecord>;
  public get countyCriminalRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "county";})
    else return [];
  }
  
  public get stateCriminalDatabaseRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "singlestate";})
    else return [];
  }

  public get stateCriminalCourtRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "statewide";})
    else return [];
  }
  
  public get utahJusticeCourtRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "UtahJusticeCourtScrape";})
    else return [];
  }

  public get utahDistrictCourtRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "UtahDistrictCourtScrape";})
    else return [];
  }

  public get nationalAliasRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "national_alias";})
    else return [];
  }

  public get OFACRecords() : Array<CriminalRecord> {
    if(this._criminalRecords) return this._criminalRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "ofac";})
    else return [];
  }

  public get hasVisibleCriminalRecords() : boolean {
    if(this._criminalRecords) {
      return this._criminalRecords.filter(rec => { return rec.excludeFromReport == false }).length > 0
    }
    else return false;
  }

  
  public get countySearchJuridictions() : string {
    if(this.countyCriminalRecords.length > 0)
    {
      return _.uniq(_.map(this.countyCriminalRecords, 'jurisdiction'))
    }else
      return '';
  }
  
  
  public get evictionRecords() : Array<EvictionRecord> {
    if(this._evictionRecords && this._evictionRecords.length > 0)
      return this._evictionRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "Eviction"})
    else 
      return [];
  }

  public get evictionVerificationRecords() : Array<EvictionRecord> {
    if(this._evictionRecords && this._evictionRecords.length > 0)
      return this._evictionRecords.filter(er => {return er.excludeFromReport == false && er.searchType == "EvictionVerification"})
    else 
      return [];
  }
  
  _addressRecords : Array<PreviousAddress>;
  public get addressRecords() : Array<PreviousAddress> {
    if(this._addressRecords)
    return this._addressRecords.filter(er => {return er.excludeFromReport == false && er.tableName != 'Person_Address';})
  else 
    return [];
  }

  _taxLienRecords : Array<ApplicantTaxLien>;
  public get taxLienRecords() : Array<ApplicantTaxLien> {
    if(this._taxLienRecords)
    return this._taxLienRecords.filter(er => {return er.excludeFromReport == false;})
  else 
    return [];
  }

  _judgmentRecords : Array<ApplicantTaxLien>;
  public get judgmentRecords() : Array<ApplicantTaxLien> {
    if(this._judgmentRecords)
    return this._judgmentRecords.filter(er => {return er.excludeFromReport == false;})
  else 
    return [];
  }

  _bankruptcyRecords : Array<ApplicantTaxLien>;
  public get bankruptcyRecords() : Array<ApplicantTaxLien> {
     if(this._bankruptcyRecords)
    return this._bankruptcyRecords.filter(er => {return er.excludeFromReport == false;})
  else 
    return [];
  }

  _aliasRecords : Array<AliasName>;
  public get aliasRecords() : Array<AliasName> {
    if(this._aliasRecords)
    return this._aliasRecords.filter(er => {return er.excludeFromReport == false;})
    else return [];
  }

  _verifyEmploy : EmploymentVerification;
  public get verifyEmploy() : EmploymentVerification {
    if(this._verifyEmploy) return this._verifyEmploy;
    else return null;
  }

  _verifyReference : ReferenceVerification;
  public get verifyReference() : ReferenceVerification {
    if(this._verifyReference) return this._verifyReference;
    else return null;
  }

  creditScoreFactors : Array<CreditScoreFactors>;
  creditApplicantInfo: CreditReportApplicantInfo;
  creditReportRemarks : Array<CreditResponseComment>;
  creditApplicantAddresses : Array<CreditReportAddress> = new Array<CreditReportAddress>();
  creditApplicantEmployers : Array<CreditReportEmployer>;
  tradeLines : Array<CreditReportTradeLine>;
  creditApplicantInquiries : Array<CreditReportInquiry>;
  creditPublicRecords : Array<CreditPublicRecordBag>;
  creditFinancialSummaryItems: Array<CreditFinancialSummaryItem>;
  customSearchRecords : Array<CustomResponseData> = new Array<CustomResponseData>();
  ssnRecords : SSNTrace;
  reportSummaryItems : Array<ReportSummaryItem> = [];
  token : string;
  password: string;
  screeningInvite : ScreeningInvite;
  packages : Array<SearchPackage>;
  ssnYears : Array<string>;
  inviteFetched : Subject<any> = new Subject<any>();
  dataLoaded : Subject<any> = new Subject<any>();
  groupedApplicantRecords :GroupedApplicantData[];
  groupPointLossReasons : GroupPMScorePointLossReason[];
  _groupHardDeclineReasons : HardDeclineReason[];
  //SCRSTP-1282: we need to know when the group hard decline rsns load, so we can add a report disclaimer if needed
  groupHardDeclineReasonsLoaded : Subject<any> = new Subject<any>();
  //adding these due to the way we have to pull in / display alias and address 
  addressDataLoaded :Subject<any> = new Subject<any>();
  aliasDataLoaded : Subject<any> = new Subject<any>();
  criminalRecordsLoaded: Subject<boolean> = new Subject<boolean>();
  identityData : IdentityResponseData;
  criminalSearchDepth : string = '';
  creditScore : string;
  creditDate : Date;
  creditScoreType : string;
  creditRepository : string = '';
  incomeData : ArgyleIncomeFetchResponse;
  incomeSources: AdditionalIncomeSource[];
  incomeOverview : ScreeningIncomeOverview;
  complianceMarkers : ComplianceMarker[] = [];
  constructor(private location: Router,
    private http : HttpClient, 
    private toast : ToastrService,
    private auth : AuthService) { 
   
  }
  public incomeSourceTypes : any[]= [
    {id : 0, name : 'Tax Documents'},
    {id : 1, name : 'VA/TANF/SSI'},
    {id : 2, name : 'Bank Statements'},
    {id : 3, name : 'Employment Offer'},
    {id : 4, name : 'Current Employment'},
    {id : 5, name : 'Other Income'},
    {id : 6, name : 'Pay Stubs'},
    {id : 7, name : 'W2'}
  ];
  
  public get groupHardDeclineReasons() : HardDeclineReason[] {
    // I need to know if anyone in the group is in prequal
    if(this.groupedApplicantRecords && this._groupHardDeclineReasons && this.groupedApplicantRecords.filter(gp => {return gp.groupInPrequal;}).length > 0){
      return this._groupHardDeclineReasons.filter(ghrd=>{ return (ghrd.declineReasonId == 3 || ghrd.declineReasonId == 4 || ghrd.declineReasonId == 5 || ghrd.declineReasonId == 2) && !ghrd.overrideCalcs; })
    }else return this._groupHardDeclineReasons;
    return 
  }
  
  public get dem_goodies() : Array<CreditReportTradeLine> {
    if(this.tradeLines)
      return this.tradeLines.filter(tl =>{ return tl.currentRatingCode == "X" || tl.currentRatingCode == "UR" || tl.currentRatingCode == "0" || tl.currentRatingCode == "01" || tl.currentRatingCode == "1" || tl.currentRatingCode == "C" || !tl.currentRatingCode });
    else
      return [];
  }

  public get applicantGoodTradeLines() : Array<CreditReportTradeLine> {
    return this.dem_goodies.filter(trd => {return !trd.isLandLordDebt && !trd.isUtilityDebt;});
  }

  public get applicantGoodTradeLinesLandlord() : Array<CreditReportTradeLine> {
    return this.dem_goodies.filter(trd => {return trd.isLandLordDebt;});
  }

  public get applicantGoodTradeLinesUtilities() : Array<CreditReportTradeLine> {
    return this.dem_goodies.filter(trd => {return trd.isUtilityDebt;});
  }  

  public get applicantNotRatedTradeLines() : Array<CreditReportTradeLine> {
    if(this.tradeLines) {
      return this.tradeLines.filter(tl => { return tl.currentRatingCode == "-" })
    }
    else
      return [];
  }

  public get reportSumItems() : Array<ReportSummaryItem> {
    return this.reportSummaryItems.filter(rsi => {
      return (rsi.searchType != 'Person' && rsi.searchType != 'Alias');
    })
  }


  public get dem_baddies() :  Array<CreditReportTradeLine> {
    if(this.tradeLines)
     {
       return this.tradeLines.filter(tl =>{ return tl.currentRatingCode != "X" && tl.currentRatingCode != "UR" && tl.currentRatingCode != "0" && tl.currentRatingCode != "01" && tl.currentRatingCode != "1" && tl.currentRatingCode != "C" && tl.currentRatingCode != "-"});
     }
    else
      return [];
  }
  

  public get applicantBadTradeLines() : Array<CreditReportTradeLine> {
      return this.dem_baddies.filter(trd => {return !trd.isLandLordDebt && !trd.isUtilityDebt;});
  }


  public get applicantBadTradeLinesLandlord() : Array<CreditReportTradeLine> {
    return this.dem_baddies.filter(trd => {return trd.isLandLordDebt;});
  }

  public get applicantBadTradeLinesUtilities() : Array<CreditReportTradeLine> {
    return this.dem_baddies.filter(trd => {return trd.isUtilityDebt;});
  }  

  public get creditASEId(): number {
    try {
      if (this.aseData.length > 0) {
        let id = this.aseData.find(sad => { return sad.searchType == "Credit" }).searchEntryId;
        return id;
      }
    } catch (error) {

    }
  }


  LoadCreditData()
  {
    this.GetCreditScoreFactorsForApplicant();
    this.GetCreditApplicantInfo();
    this.GetCreditApplicantAddresses();
    this.GetCreditApplicantEmployers();
    this.GetCreditReportTradeline();
    this.GetCreditReportInquiry();
    this.GetCreditReportPRecords();
    this.GetCreditReportRemarks();
    this.GetCreditBereau();
    this.GetCreditFinancialSummary();
  }


  FetchApplicantData(){

    
    this.http.get<Array<SearchPackage>>(environment.baseURl + `/api/search/package/rpt/` + this.screeningInvite.screeningId).subscribe(
      (scs : Array<SearchPackage>)=>{
        this.packages = scs;
        console.log('PACKAGES', scs);
        this.GetReportSummaryForApplicant();
        
      },
      (err : any)=>{
       
        this.toast.error('There was an error looking up your search package.', 'Search Package')
      },
    );
    //TESTING - PUT THIS BACK
    this.dataLoaded.next(true);
  }

  FetchApplicantInvite(){
    this.http.post(environment.baseURl + `/api/screening/invite/fetch`,{ token:this.token, pw:this.password}).subscribe((ev: any) => {
      this.screeningInvite = ev.invite;
      if(ev.hasPaymentLink){
        window.location = ev.paymentUrl
      }else{
        localStorage.setItem('STP-JWT', ev.invite.jwt);
        this.inviteFetched.next(this.screeningInvite);
        // this.GetGroupApplicantDataRecords(this.sc)
        this.FetchApplicantData();
      }
    },
    (err: any)=>{
      
      this.toast.error('There was an error looking up your invitation with this token.', 'Invitation Error');
      this.inviteFetched.next(err);
    });
  }

  // THIS IS FOR THE APPLICANT PAY SCENARIO... THEY SHOULD HAVE A TOKEN IN LOCALSTORAGE TO AUTH WITH.
  FetchApplicantInviteAppPay(){
    this.http.get(environment.baseURl + `/api/screening/invite/fetch/${this.token}`).subscribe((ev: ScreeningInvite) => {
      this.screeningInvite = ev;
      this.inviteFetched.next(this.screeningInvite);
      this.FetchApplicantData();
    },
    (err: any)=>{
      
      this.toast.error('There was an error looking up your invitation with this token.', 'Invitation Error');
      this.inviteFetched.next(err);
    });
  }

  GetGroupApplicantDataRecords(groupId : string, primaryScreeningId: number) {
    this.http.get<GroupedApplicantData[]>(environment.baseURl + `/api/reportdata/group/fetch/${groupId}`).subscribe(
      (recs : any) => {
        this.groupedApplicantRecords = recs.map(s => {return Object.assign(new GroupedApplicantData(), s)});
        this.groupedApplicantRecords.forEach(r => {
          if(r.screeningId != primaryScreeningId) r.applicantSSN = "XXXXXXXXX";
        })
      },
      (err : any) => {
       
        console.error('Error fetching the other co-applicant records');
      }); 
  }

  GetGroupIncome(reportnum: number) {
    this.http.get<any>(environment.baseURl + `/api/reportdata/group/income/${reportnum}`).subscribe(
      (recs : any) => {
        this.groupIncome = recs;
      },
      (err : any) => {
       
        console.error('Error fetching the other co-applicant records');
      }); 
  }

  GetGroupScorePointLossFactors(groupId : string) {
    this.http.get<GroupPMScorePointLossReason[]>(environment.baseURl + `/api/reportdata/group/pointloss/fetch/${groupId}`).subscribe(
      (recs : any) => {
        this.groupPointLossReasons = recs.map(s => {return Object.assign(new GroupPMScorePointLossReason(), s)});
      },
      (err : any) => {
       
      }); 
  }

  GetGroupHardDeclineReasons(groupId : string) {
    this.http.get<HardDeclineReason[]>(environment.baseURl + `/api/reportdata/group/harddeclines/fetch/${groupId}`).subscribe(
      (recs : any) => {
        this._groupHardDeclineReasons = recs.map(s => {return Object.assign(new HardDeclineReason(), s)});
        this._groupHardDeclineReasons = this._groupHardDeclineReasons.filter(ghr =>{ return !ghr.overrideCalcs;})
        this.groupHardDeclineReasonsLoaded.next(true);
      },
      (err : any) => {
        
      }); 
  }

  FetchApplicantInviteNoPW(isReport : boolean = false){
    let url = !isReport ?  environment.baseURl + `/api/screening/invite/${this.token}` : environment.baseURl + `/api/reportdata/invite/validate/${this.token}`;
    this.http.get(url).subscribe((ev: any) => {
      this.screeningInvite = ev;
      localStorage.setItem('STP-JWT', ev.jwt);
      // ////console.log(this.screeningInvite);
      this.inviteFetched.next(this.screeningInvite);
      this.token = this.screeningInvite.token;
      this.FetchApplicantData();
    },
    (err: any)=>{
      if(err.status == 401) {
        this.auth.postLoginRedirect = `screening/report/${this.token}`;
        //this.auth.logout();
      }
      else{
        this.toast.error('There was an error looking up your invitation with this token.', 'Invitation Error');
        this.inviteFetched.next(err);
      }
    });
  }

  GetCriminalRecordsForApplicant(aseId : number){
    this.http.get<Array<CriminalRecord>>(environment.baseURl + `/api/reportdata/criminal/` + aseId).subscribe(
      (scs : any)=>{
        scs.forEach(element => {
          element.selected = true;
        });
        let records = scs.map(r => {return Object.assign(new CriminalRecord, r)});
        records.forEach(element => {
          this._criminalRecords.push(element);
        });
        
        //this._criminalRecords.push(records);
        if(this.criminalRecords.length > 0){
          this.criminalSearchDepth = this.criminalRecords[0].searchType == "multistate" ? "Nationwide" : this.criminalRecords[0].searchType;
        }

        this.criminalRecordsLoaded.next(true);
      },
      (err : any)=>{
        
        ////console.log('Error fetch criminal Records')
        this.criminalRecordsLoaded.next(false);
      },
    );
  }

  GetSSNTraceForApplicant(aseId : number){
    this.http.get<Array<SSNTrace>>(environment.baseURl + `/api/reportdata/ssn/` + aseId).subscribe(
      (scs : any)=>{
        this.ssnRecords = scs[0];
        if(this.ssnRecords){
          ////console.log(this.ssnRecords);
          if(this.ssnRecords.ssnYear.indexOf("-") > 0)
          {
            this.ssnYears = this.ssnRecords.ssnYear.split("-")
          }else{
            this.ssnYears = new Array<string>();
            this.ssnYears.push(this.ssnRecords.ssnYear);
          }
        }
  
      },
      (err : any)=>{
        
        ////console.log('Error fetch criminal Records')
      },
    );
  }

  GetAliasNameRecordsForApplicant(screeningId : number){
    // RIQ-5037: Updated to use credit-only alias endpoint
    this.http.get<Array<AliasName>>(environment.baseURl + `/api/reportdata/alias/credit/` + screeningId).subscribe(
      (scs : any)=>{
        this._aliasRecords = scs;
        this.aliasDataLoaded.next(true);
      },
      (err : any)=>{
        console.error('Error fetching credit alias records');
      },
    );
  }

  GetReportSummaryForApplicant(){
    this.http.get<Array<ReportSummaryItem>>(environment.baseURl + `/api/reportdata/report/summary/` + this.token).subscribe(
      (scs : any)=>{
        this.reportSummaryItems = scs;
        this.reportSummaryItems.forEach(element => {
          if(element.searchType === 'Person') {
            this.reportSummaryItems.splice(this.reportSummaryItems.indexOf(element, 1));
          }       

          if(element.alerts) element.alerts = element.alerts.replace('Unspecified criminal record offense located. A county search is recommended to obtain more information.','');
        });
      },
      (err : any)=>{
        
        ////console.log('Error fetch alias name Records')
      },
    );
  }


  GetEvictionRecordsForApplicant(aseId : number, searchType: string){
    this.http.get<Array<EvictionRecord>>(environment.baseURl + `/api/reportdata/eviction/` + aseId).subscribe(
      (scs : any)=>{
        scs.forEach(element => {
          element.selected = true;
        });

        let records = scs.map(r => {return Object.assign(new EvictionRecord, r)});
        records.forEach(element => {
          element.searchType = searchType;
          this._evictionRecords.push(element);
        });

        console.log(this._evictionRecords)
      },
      (err : any)=>{
        
        ////console.log('Error fetch eviction Records')
      },
    );
  }

  GetAddressRecordsForApplicant(screeningId : number){
    this.http.get<Array<PreviousAddress>>(environment.baseURl + `/api/reportdata/address/` + screeningId).subscribe(
      (scs : any)=>{
        this._addressRecords = scs.map(e =>{ return Object.assign(new PreviousAddress, e)});
        // ////console.log(this);
        this.addressDataLoaded.next(true);
      },
      (err : any)=>{
        
        ////console.log('Error fetch Address Records')
      },
    );
  }

  GetJudgmentRecordsForApplicant(){
    this.http.get<Array<ApplicantTaxLien>>(environment.baseURl + `/api/reportdata/judgment/` + this.token).subscribe(
      (scs : any)=>{
        this._judgmentRecords = scs.map(c =>{return Object.assign(new ApplicantTaxLien, c)});
        // ////console.log(this);
      },
      (err : any)=>{
        
        ////console.log('Error fetch Tax Judgment Records')
      },
    );
  }

  GetTaxLienRecordsForApplicant(){
    this.http.get<Array<ApplicantTaxLien>>(environment.baseURl + `/api/reportdata/lien/` + this.token).subscribe(
      (scs : any)=>{
        this._taxLienRecords = scs.map(c =>{return Object.assign(new ApplicantTaxLien, c)});
        // ////console.log(this);
      },
      (err : any)=>{
        
        ////console.log('Error fetch Tax Lien Records')
      },
    );
  }

  GetBankruptcyRecordsForApplicant(){
    this.http.get<Array<ApplicantTaxLien>>(environment.baseURl + `/api/reportdata/bankrupcty/` + this.token).subscribe(
      (scs : any)=>{
        this._bankruptcyRecords = scs.map(c =>{return Object.assign(new ApplicantTaxLien, c)});
        // ////console.log(this);
      },
      (err : any)=>{
        console.error('Error fetch Bankruptcy Records')
      },
    );
  }

  GetCreditScoreFactorsForApplicant(){
    this.http.get<Array<CreditScoreFactors>>(environment.baseURl + `/api/reportdata/credit/score/` + this.creditASEId).subscribe(
      (scs: any) => {
        this.creditScoreFactors = scs.map((c: any) => Object.assign(new CreditScoreFactors, c));
        
        if (this.creditScoreFactors && this.creditScoreFactors.length > 0 ) {
          //RIQ-2684: the credit score can be null now; we hide the score section if so
          this.creditScore = !this.creditScoreFactors[0].value ? null : this.creditScoreFactors[0].value ;
          this.creditDate = this.creditScoreFactors[0].orderDate;
          this.creditScoreType = this.creditScoreFactors[0].modelNameType;
          ////console.log(this.creditScore);
        }else{
          this.creditScore = null;
        }
      },
      (err : any)=>{
        console.error('Error fetch Bankruptcy Records')
      },
    );
  }

  GetCreditApplicantInfo(){
    this.http.get<CreditReportApplicantInfo>(environment.baseURl + `/api/reportdata/credit/applicantinfo/` + this.creditASEId).subscribe(
      (scs : any)=>{
        this.creditApplicantInfo = scs.length == 0 ? undefined : Object.assign(new CreditReportApplicantInfo(), scs[0]);
        //RIQ-3262: EFX sends us garbage so we have to handle it like garbage
        if(new Date(scs[0]?.dob).getFullYear() >= (new Date()).getFullYear()-1) {
          this.creditApplicantInfo.dob = null;
        }
        console.log('credit app info: ', this.creditApplicantInfo);
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }


  GetCreditReportRemarks(){
    this.http.get<CreditResponseComment>(environment.baseURl + `/api/reportdata/credit/remarks/` + this.creditASEId).subscribe(
      (scs : any)=>{
        this.creditReportRemarks = [];
       scs.forEach(element => {
        this.creditReportRemarks.push(Object.assign(new CreditResponseComment(), element));
       });
       
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }

  GetCreditApplicantAddresses(){
    this.http.get<CreditReportAddress>(`${environment.baseURl}/api/reportdata/credit/addresses/${this.creditASEId}`).subscribe(
      (scs : any)=>{
        if(scs) this.creditApplicantAddresses = scs.map(s => {return Object.assign(new CreditReportAddress(), s)});
        ////console.log(this.creditApplicantAddresses)
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }

  GetCreditApplicantEmployers(){
    this.http.get<CreditReportEmployer>(`${environment.baseURl}/api/reportdata/credit/employer/${this.creditASEId}`).subscribe(
      (scs : any)=>{
        this.creditApplicantEmployers = scs.map(s => {return Object.assign(new CreditReportEmployer(), s)});
        ////console.log(this.creditApplicantEmployers)
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }

  GetCreditReportTradeline(){
    this.http.get<CreditReportTradeLine>(`${environment.baseURl}/api/reportdata/credit/tradeline/${this.creditASEId}`).subscribe(
      (scs : any)=>{
        this.tradeLines = scs.map(s => {return Object.assign(new CreditReportTradeLine(), s)});
        this.tradeLines.forEach(element => {
          element.buildPaymentHistory();
        });
        ////console.log(this.tradeLines)
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }

  GetCreditReportInquiry(){
    this.http.get<CreditReportInquiry>(`${environment.baseURl}/api/reportdata/credit/inquiry/${this.creditASEId}`).subscribe(
      (scs : any)=>{
        this.creditApplicantInquiries = scs.length == 0 ? undefined : scs.map(s => {return Object.assign(new CreditReportInquiry(), s)});
        ////console.log(this.creditApplicantInquiries)
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }

  GetCreditFinancialSummary(){
    this.http.get<CreditReportInquiry>(`${environment.baseURl}/api/reportdata/credit/fsummary/${this.creditASEId}`).subscribe(
      (scs : any)=>{
        this.creditFinancialSummaryItems = scs.length == 0 ? undefined : scs.map(s => {return Object.assign(new CreditFinancialSummaryItem(), s)});
        //console.log('fin summary: ', this.creditFinancialSummaryItems);
      },
      (err : any)=>{
        console.error('fin sum error: ', err);
      },
    );
  }

  GetCreditReportPRecords(){
    this.http.get<CreditPublicRecordBag>(`${environment.baseURl}/api/reportdata/credit/precords/${this.creditASEId}`).subscribe(
      (scs : any)=>{
        this.creditPublicRecords = scs.map(s => {return Object.assign(new CreditPublicRecordBag(), s)});
        console.log('Public records: ', this.creditPublicRecords)
      },
      (err : any)=>{
        console.error('Error fetch  Records')
      },
    );
  }

  GetCreditBereau() {
    //SCRSTP-1674: we should infer this from the respository setting on the credit search.
    let search = this.packages[0].searches.find(srch => { return srch.searchType === VendorResponseTypes.Credit });
    if(!search) this.creditRepository = "";
    else {
      if(search.vendor == 8) this.creditRepository = 'Equifax'
      else if(search.vendor == 11) this.creditRepository = 'Transunion'
      else
        this.creditRepository = CreditRepositories[search.searchMeta["repository"]] || "";
      console.log('REPO:', this.creditRepository);
    }
  }

  GetEmploymentVerifications(aseId: number) {
    this.http.get<EmploymentVerification>(`${environment.baseURl}/api/reportdata/verification/employment/${aseId}`).subscribe(
      (vers : EmploymentVerification) => {
        this._verifyEmploy = vers;
      },
      (err : any) => {
        console.error('Error fetch employment ver records');
      }
    )
  }

  GetReferenceVerifications(aseId: number) {
    this.http.get<ReferenceVerification>(`${environment.baseURl}/api/reportdata/verification/reference/${aseId}`).subscribe(
      (vers : ReferenceVerification) => {
        this._verifyReference = vers;
      },
      (err : any) => {
        console.error('Error fetch reference ver records');
      }
    )
  }


  GetIdentityVerificationData(aseId : number) {
    this.http.get<IdentityResponseData>(environment.baseURl + `/api/reportdata/identity/${aseId}`).subscribe(
      (recs : any) => {
        this.identityData = recs[0];
        console.log('ID DATA', this.identityData);
      },
      (err : any) => {
        console.error('Error fetching identity verification data');
      }
    );
  }

  GetCustomSearchResponseRecords(aseId : number): void {
    this.http.get<CustomResponseData[]>(environment.baseURl + `/api/reportdata/custom-search/${aseId}`).subscribe((recs: CustomResponseData[]) => {
      if(recs.length > 0) {
        this.customSearchRecords.push(Object.assign(new CustomResponseData(), recs[0]));
      }
    },
    (err) => {

    }); 
  }

  GetRRReasons(scrn : number): void {
    this.http.get<ReviewRequiredReason[]>(environment.baseURl + `/api/reportdata/rr-reasons/${scrn}`).subscribe((recs: ReviewRequiredReason[]) => {
      this._rrreasons = recs;
    },
    (err) => {

    }); 
  }

  GetIncomeDataForReport(scrn : number){
    return this.http.get<ArgyleIncomeFetchResponse>(environment.baseURl + `/api/reportdata/income/fetch/${scrn}`).subscribe((dta: ArgyleIncomeFetchResponse)=> {
      this.incomeData = {
        ...dta,
        streams: (dta?.streams ?? []).map((s) => normalizeArgyleIncomeStream(s)),
      };
    }, 
    (err)=>{}); 
  }


  GetIncomeOverviewForReport(scrn : number){
    return this.http.get<ScreeningIncomeOverview>(environment.baseURl + `/api/reportdata/income/overview/${scrn}`).subscribe((dta: ScreeningIncomeOverview)=> {
      this.incomeOverview = dta;
    }, 
    (err)=>{}); 
  }

  // income sources
  GetIncomeSourcesForReport(scrn : number){
    return this.http.get<AdditionalIncomeSource[]>(environment.baseURl + `/api/reportdata/income/sources/${scrn}`).subscribe((dta: AdditionalIncomeSource[])=> {
      this.incomeSources = dta;
    }, 
    (err)=>{}); 
  }


  // draft income sources (income wizard)
  draftSources: DraftIncomeSource[] = [];
  draftSourcesLoaded = false;

  get hasDraftSources(): boolean {
    return this.draftSourcesLoaded && this.draftSources.length > 0;
  }

  GetDraftSourcesForReport(scrn: number, locationId: number): Observable<DraftIncomeSource[]> {
    return this.http.get<{ enabled: boolean, sources: DraftIncomeSource[] }>(environment.baseURl + `/api/reportdata/income/drafts/${scrn}/${locationId}`).pipe(
      tap((dta) => {
        this.draftSources = dta?.sources ?? [];
        this.draftSourcesLoaded = true;
      }),
      map((dta) => dta?.sources ?? [])
    );
  }


  GetComplianceMarkers(screeningId: number, onComplete?: () => void): void {
    this.http.get<ComplianceMarker[]>(`${environment.baseURl}/api/reportdata/compliance-markers/${screeningId}`).subscribe(
      (markers: ComplianceMarker[]) => {
        this.complianceMarkers = markers || [];
        if (onComplete) { onComplete(); }
        },
        () => {
        this.complianceMarkers = [];
        if (onComplete) { onComplete(); }
        }
      );
    }
}
